<div *ngIf="!tokenApp" class="home_fixed boxs" tourAnchor="dashboard-header">
  <div style='padding-right: 40px;' class="homehead boxs">

    <div class="homehead_lft p_arr0_dn">
      <div class="row">
        <div class="alert text-center cookiealert" *ngIf="showCookies" role="alert">
          <div class="col-xs-6 col-sm-6 col-md-6">
            <p>{{'term.we_use_cookies_desc'|translate}}.</p>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 right">
            <button type="button" (click)="acceptCookies()" class="btn btn-primary btn-sm agree" aria-label="Close">
              {{'term.i_agree'|translate}}
            </button>
            <button type="button" (click)="privacyPolicy()" class="btn btn-primary btn-sm terms" aria-label="Close">
              {{'term.privacy_policy'|translate}}
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-item-center flex-wrap">
        <div class="d-flex flex-row" style="height: 30px;">
          <div class="pt-1">
            <p class="textcolor">
              <a href="javascript:void(0)" data-toggle="tab" (click)="userProfileBox($event)" class="textcolor">
                <span class="textcolor">{{userData.username}}</span>
              </a>
              <button class="gradient-box" *ngIf="userData.verificationStatus" (click)="userProfileBox($event)">
                <span>
                  {{verificationStatusEnum?verificationStatusEnum:(userData.verificationStatus?('verification_status.verified'|translate):(''))}}
                </span>
              </button>
              <button class="gradient-box2"
                *ngIf="!userData.verificationStatus && (userData.verificationStatusString  === 'PENDING' || userData.verificationStatusString  === 'SUBMITTED' || userData.verificationStatusString  === 'FAILED' || userData.verificationStatusString  === 'ONBOARDING_PENDING' || userData.verificationStatusString  === 'ONBOARDING_COMPLETED')"
                (click)="userProfileBox($event)">
                <span>
                  {{verificationStatusEnum?verificationStatusEnum:(userData.verificationStatus?('verification_status.verified'|translate):(''))}}
                </span>
              </button>

              <i class="fa fa-angle-down arrow_down cursorPointer" aria-hidden="true"
                (click)="userProfileBox($event)"></i>
            </p>
            <div class="drop_down_hd boxs">
              <div class="drop_menu_hd boxs">
                <div (click)="routerBox('/profile')" class="col-sm-6 nopadding">
                  <div class="user_infobx boxs">
                    <a class=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 20 26">
                        <defs>
                          <linearGradient id="gradient" gradientUnits="userSpaceOnUse" fy="90%">
                            <stop offset="0" style="stop-color:#89f7fe" />
                            <stop offset="1" style="stop-color:#66a6ff" />
                            <animate attributeName="fy" from="0" to="1" dur="5s" repeatCount="indefinite" />
                          </linearGradient>
                        </defs>
                        <path fill="#fff" fill-rule="evenodd"
                          d="M16.667 26H5.556c-.614 0-1.112-.5-1.112-1.116 0-.616.498-1.115 1.112-1.115h11.11c.614 0 1.112-.5 1.112-1.116v-4.629a1.818 1.818 0 0 0-.99-1.461 18.067 18.067 0 0 0-13.577 0 1.818 1.818 0 0 0-.989 1.461v6.86c0 .617-.497 1.116-1.11 1.116C.496 26 0 25.5 0 24.884v-6.86a4.005 4.005 0 0 1 2.378-3.536 20.27 20.27 0 0 1 15.244 0A4.005 4.005 0 0 1 20 18.024v4.63A3.34 3.34 0 0 1 16.667 26zM16 5.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0zm-2 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z" />
                      </svg>
                      <span class="textcolor">{{'header.user_info'|translate}}</span></a>
                  </div>
                </div>
                <div (click)="routerBox('/profile/verification')" class="col-sm-6 nopadding">
                  <div class="user_infobx boxs">
                    <a class=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 24 24">
                        <defs>
                          <linearGradient id="gradient" gradientUnits="userSpaceOnUse" fy="90%">
                            <stop offset="0" style="stop-color:#89f7fe" />
                            <stop offset="1" style="stop-color:#66a6ff" />
                            <animate attributeName="fy" from="0" to="1" dur="5s" repeatCount="indefinite" />
                          </linearGradient>
                        </defs>
                        <path fill="url(#a)" fill-rule="evenodd"
                          d="M108.811 58.151c-.001-.68-.13-1.15.445-1.516a1.974 1.974 0 0 1 1.893-.147 9.335 9.335 0 0 0 11.657-3.382 9.332 9.332 0 0 0-1.54-12.038 9.336 9.336 0 0 0-12.133-.339 9.332 9.332 0 0 0-2.21 11.933 1.333 1.333 0 0 1-2.308 1.333 11.998 11.998 0 0 1-1.467-7.893 12 12 0 0 1 22.167-4.233 11.998 11.998 0 0 1-1.038 13.741 12.003 12.003 0 0 1-13.274 3.705l-2.192-1.164zm5.808-6.543l5.076-5.386a1.407 1.407 0 0 0-.067-1.828 1.216 1.216 0 0 0-1.722-.07l-4.175 4.43-1.637-1.737a1.216 1.216 0 0 0-1.722.07 1.407 1.407 0 0 0-.067 1.828l2.538 2.693a1.218 1.218 0 0 0 1.789 0h-.013z"
                          transform="translate(-103 -36)" />
                      </svg>
                      <span class="textcolor">{{'header.verification'|translate}}</span></a>
                  </div>
                </div>
                <div *ngIf="userData.verificationStatus" (click)="routerBox('/profile/referral-program')"
                  class="col-sm-6 nopadding">
                  <div class="user_infobx boxs">
                    <a class=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 24 22">
                        <defs>
                          <linearGradient id="gradient" gradientUnits="userSpaceOnUse" fy="90%">
                            <stop offset="0" style="stop-color:#66a6ff" />
                            <stop offset="1" style="stop-color:#89f7fe" />
                            <animate attributeName="fy" from="0" to="1" dur="5s" repeatCount="indefinite" />
                          </linearGradient>
                        </defs>
                        <path fill="#0C133E" fill-rule="evenodd"
                          d="M8 21H3a3 3 0 0 1-3-3v-3.2a3.08 3.08 0 0 1 1.87-2.72 15.41 15.41 0 0 1 8.09-.88 1.013 1.013 0 1 1-.32 2 13.43 13.43 0 0 0-7 .77 1.11 1.11 0 0 0-.6.86V18a1 1 0 0 0 1 1h5a1 1 0 1 1 0 2H8zm4-16.44A4.5 4.5 0 1 0 7.5 9 4.47 4.47 0 0 0 12 4.56zm-2 0a2.5 2.5 0 1 1-2.5-2.44A2.47 2.47 0 0 1 10 4.56zm14 14.11v-3.36a2.73 2.73 0 0 0-1.66-2.42 12.87 12.87 0 0 0-9.49 0 2.73 2.73 0 0 0-1.66 2.42V20a1 1 0 0 0 2 0v-4.68a.76.76 0 0 1 .39-.55 10.89 10.89 0 0 1 8 0 .76.76 0 0 1 .39.55v3.36a.34.34 0 0 1-.35.33H16a1 1 0 1 0 0 2h5.65A2.34 2.34 0 0 0 24 18.67zM21 6.54a3.5 3.5 0 1 0-3.5 3.45A3.48 3.48 0 0 0 21 6.55v-.01zm-2 0a1.5 1.5 0 1 1-1.5-1.45A1.48 1.48 0 0 1 19 6.55v-.01z" />
                      </svg>
                      <span class="textcolor">{{'header.referral_programe'|translate}}</span></a>
                  </div>
                </div>
                <div (click)="routerBox('/profile/reputation')"
                  [ngClass]="userData.verificationStatus? 'col-sm-6 nopadding': 'col-sm-12 nopadding'">
                  <div class="user_infobx boxs">
                    <a class=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 23 22">
                        <defs>
                          <linearGradient id="gradient" gradientUnits="userSpaceOnUse" fy="90%">
                            <stop offset="0" style="stop-color:#66a6ff" />
                            <stop offset="1" style="stop-color:#89f7fe" />
                            <animate attributeName="fy" from="0" to="1" dur="5s" repeatCount="indefinite" />
                          </linearGradient>
                        </defs>
                        <path fill="#0C133E" fill-rule="evenodd"
                          d="M17.535 21.816a1.5 1.5 0 0 1-.7-.17l-5-2.61a1 1 0 0 0-.93 0l-1.14.6a1 1 0 0 1-.93-1.77l1.14-.6a3 3 0 0 1 2.79 0l4.06 2.14-.78-4.52a3 3 0 0 1 .86-2.65l3.29-3.2-4.54-.66a3 3 0 0 1-2.26-1.64l-2-4.11-2 4.11a3 3 0 0 1-2.26 1.64l-4.54.66 3.29 3.2a3 3 0 0 1 .86 2.66l-.95 5.52a1.014 1.014 0 0 1-2-.34l.95-5.52a1 1 0 0 0-.29-.89l-4-3.91a1.5 1.5 0 0 1 .83-2.56l5.54-.81a1 1 0 0 0 .75-.55l2.48-5a1.5 1.5 0 0 1 2.69 0l2.48 5a1 1 0 0 0 .75.55l5.54.81a1.5 1.5 0 0 1 .83 2.56l-4 3.91a1 1 0 0 0-.29.88l.95 5.52a1.5 1.5 0 0 1-1.48 1.76l.01-.01z" />
                      </svg>
                      <span class="textcolor">{{'header.reputation'|translate}}</span></a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row" style="height: 30px;">
          <div class="btn-group usd_hide2" role="group" aria-label="Basic example">
            <!-- <button class="btn-exchange btn-transaction"
              (click)="quickExchangeModal.openQuickExchangePopup()">{{'exchange.exchange'|translate}}</button> -->
            <button *ngIf="userService.isEnabledModule('OBSIPAY')"  class="btn-obsipay btn-transaction2" (click)="obsipayModal.openObsidiamModal()"></button>
          </div>
        </div>
      </div>
    </div>
    <div tourAnchor="coin-header-step" class="homehead_rht">

      <div class="homeswitch">
        <div (click)="showTourOptions()" class="switch_out" style="margin-left: 0;">
          <label class="switch marginTour cursorPointer">{{'header.tour'|translate}}</label>
        </div>
      </div>
      <div style="margin:4px 30px 0 10px;">
        <a href="javascript:void(0)" class="bell bellicon" (click)="showCalculator()"><span><i class="fas fa-calculator"
              style="color: #0c133f; font-size: 19px;"></i> </span></a>
      </div>
      <div tourAnchor="notifications-header-step" class=" bell_ic ">
        <a href="javascript:void(0)" class="bell bellicon" (click)="notificationBox($event)"><img
            src="{{imgUrl + 'img/obsidiam_bell.svg'}}" [ngStyle]="{marginRight: notifiations.length ? '10px': '0'}">
          <span class="badge badge-danger" *ngIf="isClicked && notifiations.length>0">{{notifiations.length}}</span></a>

        <div class="drop_downN3 boxs" style="padding: 0px; right: -20px; z-index: 9000;">
          <div class="d-flex justify-content-between pt-2 pb-2">
            <li>
              <div class="form-group position-absolute" style="left: 0;top: 5px; margin-left: 5px; margin-bottom: 0;"
                [style.display]="selectAllNotification == true && notifiations.length > 0 ? 'block':'none'">
                <input class="checkbox-style" type="checkbox" value="" id="flexCheckDefault"
                  (click)="checkedEvent($event)">
                <label class="checkbox-style-3-label" for="flexCheckDefault" *ngIf="selectAllNotification === true">
                  {{'header.unselect_all'|translate}}
                </label>
              </div>
            </li>
            <li><a href="javascript:void(0)" class="all-notifications1 read-all position-absolute"
                style="left: 0;top: 8px; margin-left: 5px; margin-bottom: 0;"
                *ngIf="!activeDeleteOption == false && notificationSelected == true && numberOfChecked > 0"
                (click)="updateNotification()"><i class="far fa-trash-alt"></i>&nbsp;<span
                  class="text">{{'header.selected'|translate}}</span>&nbsp;<span
                  class="number">{{numberOfChecked}}</span></a></li>
            <li><a *ngIf="notifiations.length" href="javascript:void(0)"
                (click)="selectAllNotification == true?readAllNotifications():selectAllNotiButton($event)"
                class="all-notifications1 read-all">{{selectAllNotification ==
                true?('header.read_all'|translate):('header.select_all'|translate)}}</a></li>
          </div>
          <div style="max-height: 300px; overflow-y: auto;" class="notificationDiv">
            <ul class="drop_menu3 boxs notifications">
              <li class="notificationLi" *ngFor="let n of notifiations; let i = index">
                <div class="form-group"
                  style="display: flex; justify-content: center; align-items: center; padding: 10px 0;margin-bottom: 0;"
                  id="formCheckBox">
                  <input class="checkbox-style" type="checkbox" value="" [id]="'flexCheckDefault_' + i"
                    (click)="selectNotification($event, n); countChecked()">
                  <label class="checkbox-style-3-label" [for]="'flexCheckDefault_' + i" [id]="'flexCheckDefault_' + i">
                  </label>
                </div>
                <a style="margin-left: 0px; width: 268px; height: auto;" href="javascript:void(0)"
                  (click)="readNootification(n)">

                  <span class="d-flex flex-md-row justify-content-between">
                    <h4 class="textcolor notificationText"><b>{{n.title}}</b></h4>
                    <!-- <i class="notification-base notification-indicator-danger notification-base-ripple"></i> -->
                  </span>
                  <p class="textcolor notificationText">{{n.message}}</p>
                </a>
                <div class="form-group" style="display: flex; padding: 16px 0;" id="formCheckBox">
                  <i class="notification-base notification-indicator-danger notification-base-ripple"></i>

                </div>
              </li>
            </ul>
          </div>

          <li><a [routerLink]="['/notifications']" class="all-notifications"
              style="text-align:center; margin-left: 0;">{{'header.all_notification'|translate}}</a></li>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 usd_div usd_hide" style="padding-right: 0;">
        <div class=" form-group whit_b whit_bb1" style="padding: 0 0 0 0; float: left; display:block; align-items: center;
                                                   margin-right: 15px; margin-bottom: 0;">
          <div>
            <input (click)="searchCurrency($event)" readonly type="text" id="searchcurrency2" autocomplete="none"
              name="searchcurrency2"
              [placeholder]="currentCurrency? currentCurrency['fullName'+(currentLang=='en'?'':(currentLang|uppercase))]: ''"
              class="fitCurrency inputClass textcolor req_sec coin_inptt cursorPointer">
            <span (click)="searchCurrency($event)" style="top: auto; left: auto; right: auto;"><i
                id="searchcurrencyImg2" [ngClass]="currencies && currencies.length?'fa-angle-up':'fa-angle-down'"
                class="fa  fa_dwn textcolor cursorPointer" aria-hidden="true"
                style="top: auto; left: auto; right: auto; margin-top: 7px; margin-left: -25px;"></i></span>
          </div>
          <div class="drop_down drop_down1 dropWidth" id="searchcurrencyDrop2" *ngIf="currencies && currencies.length"
            style="top: auto; left: auto; max-height: 190px; overflow-y: auto; width: auto">
            <ul class="drop_menu boxs">

              <li *ngIf="usdDollar;">
                <a href="javascript:void(0)" (click)="changeCurrency(usdDollar)" class="active textcolor"
                  style="padding: 5px 10px;">
                  <i class="bit_para">{{usdDollar?
                    usdDollar['fullName'+(currentLang=='en'?'':(currentLang.toUpperCase()))]: ''}}</i></a>
              </li>

              <li *ngFor="let c of currencies;">
                <a href="javascript:void(0)" (click)="changeCurrency(c)" class="active textcolor"
                  style="padding: 5px 10px;">
                  <i class="bit_para">{{c? c['fullName'+(currentLang=='en'?'':(currentLang.toUpperCase()))]: ''
                    }}</i></a>
              </li>

            </ul>
          </div>
        </div>
      </div>

      <div class="col-sm-3 col-md-3 col-lg-3 usd_div usd_hide" style="width: 140px; padding: 0;">
        <div class=" form-group whit_b whit_bb1" style="padding: 0 0 0 0; float: left; display:block; align-items: center;
                                                   margin-right: 15px; margin-bottom: 0;">
          <div>
            <div (click)="searchLanguages($event)" id="searchlanguage2" style="width: 145px; min-width: 60px;
            display: inline-flex; padding: 6px 10PX;"
              class="fitCurrency inputClass textcolor req_sec coin_inptt cursorPointer">
              <img height="15px" style="margin: 3px 10px 0 0;"
                [src]="'https://cdn-dev.obsidiam.com/img/flags/obsidiam_' + language.lang.toString().toLowerCase() + '_flag.svg'">
              {{language.text}}
            </div>
            <span (click)="searchLanguages($event)" style="top: auto; left: auto; right: auto;"><i
                id="searchlanguageImg2" [ngClass]="languages && languages.length?'fa-angle-up':'fa-angle-down'"
                class="fa  fa_dwn textcolor cursorPointer" aria-hidden="true"
                style="top: auto; left: auto; right: auto; margin-top: 7px; margin-left: -25px;"></i></span>
          </div>
          <div class="drop_down drop_down1 dropWidth2" id="searchlanguageDrop2" *ngIf="languages && languages.length"
            style="top: auto; left: auto; max-height: 150px; overflow-y: auto; width: 145px;">
            <ul class="drop_menu boxs">

              <li *ngFor="let lang of languages;">
                <a href="javascript:void(0)" (click)="changeLanguageLocal(lang)" class="active textcolor"
                  style="padding: 5px 10px;">
                  <i class="bit_para" style="display: inline-flex">
                    <img height="15px" style="margin: 5px 10px 0 0;"
                      [src]="'https://cdn-dev.obsidiam.com/img/flags/obsidiam_' + lang.lang.toString().toLowerCase() + '_flag.svg'">
                    {{lang.text}} </i></a>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <button class="hamburger hamburger--squeeze" [ngClass]="menuActive?'is-active':''" (click)="menuEvent()"
        type="button" aria-label="Menu" aria-controls="navigation">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>
  </div>
  <div class="home_hide boxs">

    <div class="homehead_lft hideBox">
      <div class="d-flex flex-row" style="height: 30px;">
        <div *ngIf="userService.isEnabledModule('OBSIPAY')" class="btn-group" role="group" aria-label="Basic example">
          <button class="btn-obsipay btn-transaction2" (click)="obsipayModal.openObsidiamModal()"></button>
        </div>
      </div>
    </div>
    <div class="homehead_rht">
      <div class="usd_div" style="width: 60%;">
        <div class=" form-group whit_b whit_bb1" style="padding: 0 0 0 0; float: left; display:block; align-items: center;
                                                   margin-right: 5px; margin-bottom: 0; width: 100%;">
          <div>
            <input (click)="searchCurrency($event)" readonly type="text" id="searchcurrency1" autocomplete="none"
              name="searchcurrency1"
              [placeholder]="currentCurrency?currentCurrency['fullName'+(currentLang=='en'?'':(currentLang |uppercase))]: ''"
              class="fitCurrency inputClass textcolor req_sec coin_inptt cursorPointer">
            <span (click)="searchCurrency($event)" style="top: auto; left: auto; right: auto;"><i
                id="searchcurrencyImg1" [ngClass]="currencies && currencies.length?'fa-angle-up':'fa-angle-down'"
                class="fa  fa_dwn textcolor cursorPointer arrowElement" aria-hidden="true"
                style="top: auto; left: auto; right: auto; margin-top: 7px; margin-left: -25px;"></i></span>
          </div>
          <div class="drop_down drop_down1" id="searchcurrencyDrop1" *ngIf="currencies && currencies.length"
            style="top: auto; left: auto; max-height: 150px; overflow-y: auto; min-width: 100%;">
            <ul class="drop_menu boxs">

              <li *ngIf="usdDollar;">
                <a href="javascript:void(0)" (click)="changeCurrency(usdDollar)" class="active textcolor"
                  style="padding: 5px 10px;">
                  <i class="bit_para">{{usdDollar?
                    usdDollar['fullName'+(currentLang=='en'?'':(currentLang.toUpperCase()))]: ''}}</i></a>
              </li>

              <li *ngFor="let c of currencies;">
                <a href="javascript:void(0)" (click)="changeCurrency(c)" class="active textcolor"
                  style="padding: 5px 10px;">
                  <i class="bit_para">{{c? c['fullName'+(currentLang=='en'?'':(currentLang.toUpperCase()))]:
                    ''}}</i></a>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <div class="usd_div" style="width: 40%;">
        <div class=" form-group whit_b whit_bb1" style="padding: 0 0 0 0; float: left; display:block; align-items: center;
                                                   margin-right: 15px; margin-bottom: 0; width: 100%;">
          <div>
            <div (click)="searchLanguages($event)" id="searchlanguage1" style="min-width: 100%; margin-left: 2%;
            display: inline-flex; padding: 6px 10PX;"
              class="fitCurrency inputClass textcolor req_sec coin_inptt cursorPointer">
              <img height="15px" style="margin: 5px 10px 0 0;"
                [src]="'https://cdn-dev.obsidiam.com/img/flags/obsidiam_' + language.lang.toString().toLowerCase() + '_flag.svg'">
              {{language.text}}
            </div>
            <span (click)="searchLanguages($event)" style="top: auto; left: auto; right: auto;"><i
                id="searchlanguageImg1" [ngClass]="languages && languages.length?'fa-angle-up':'fa-angle-down'"
                class="fa  fa_dwn textcolor cursorPointer" aria-hidden="true"
                style="top: 0; left: auto; right: 5px; margin-top: 7px; margin-left: -25px;"></i></span>
          </div>
          <div class="drop_down drop_down1 dropWidth2" id="searchlanguageDrop1" *ngIf="languages && languages.length"
            style="top: auto; left: auto; max-height: 150px; overflow-y: auto; width: 100%; margin-left: 2%">
            <ul class="drop_menu boxs">

              <li *ngFor="let lang of languages;">
                <a href="javascript:void(0)" (click)="changeLanguageLocal(lang)" class="active textcolor"
                  style="padding: 5px 10px;">
                  <i class="bit_para" style="display: inline-flex">
                    <img height="15px" style="margin: 5px 10px 0 0;"
                      [src]="'https://cdn-dev.obsidiam.com/img/flags/obsidiam_' + lang.lang.toString().toLowerCase() + '_flag.svg'">
                    {{lang.text}} </i></a>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- verify popup start -->
  <div class="veirifyPopup">
    <div class="getverfiy boxs boxes-3" style="height: 110px; width: 275px !important;">
      <a href="javascript:void(1)" style="width: 100%; height: 100%;">
        <div class="getVerifiedBox icon" style="width: 100%; height: 100%;">
          <div class="text-box">
            <div style="text-align: right;">
              <h3>{{'deposite.get_verify'|translate}}</h3>
            </div>
            <button style="float: right;" (click)="routerToVerification()"
              class="startButtonWhite textcolor">{{'wallet.startNow'|translate}}</button>
          </div>
        </div>
      </a>
    </div>
  </div>
<!-- verify popup ends -->
</div>

<div id="header_time_out" class="modal fade qrcode" role="dialog" style=" padding-left: 0px;" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content boxs">
      <div class="modal-body boxs">
        <div class="qrcode_scan amount_div boxs">
          <img src="{{imgUrl + 'img/obsidiam_info_symbol.svg'}}" class="img-responsive" alt="qr_code">
          <h5>{{'header.change_preffered_currency'|translate}} </h5>
          <p>{{message}}</p>
          <div class="boxs conf_btn">
            <ul>
              <li><a href="javascript:;" data-dismiss="modal" class="back_btn">{{'go_back'|translate}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="header_success_po" class="modal fade qrcode" role="dialog" style=" padding-left: 0px;" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content boxs">
      <div class="modal-body boxs">
        <div class="qrcode_scan amount_div boxs">
          <div class="boxs conf_img">
            <img src="{{imgUrl + 'img/obsidiam_green_tick.svg'}}" class="img-responsive" alt="image">
          </div>
          <div class="boxs conf_hd succ_hd">
            <h5 class="textcolor">{{'success'|translate}}</h5>
            <p class="textcolor">{{message}}
            </p>
          </div>
          <div class="sign_btn green_btn boxs">
            <a href="javascript:;" data-dismiss="modal">{{'go_back'|translate}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade tab-modal" id="approve-order-header" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  style="display: none;">
  <div class="modal-dialog custom-modal" role="document">
    <div class="modal-content">
      <div id="rootwizard">
        <div class="step_modal order-preview">
          <div class="sidebar-left">
            <div class="text-box">
              <h3 *ngIf="userData.preferredLanguage == 'en'"><span>{{'header.order'|translate}} </span>
                {{'header.approval'|translate}}</h3>
              <h3 *ngIf="userData.preferredLanguage != 'en'">
                {{'header.approval'|translate}} {{'header.of'|translate}} <span>{{'header.order'|translate}}</span></h3>
              <p>
                {{'header.approve_reject'|translate: {type: approvalData.orderType &&
                approvalData.orderType.toLowerCase() === 'sell' ? ('buy_sell_detail.buyer' | translate) :
                ('buy_sell_detail.seller' | translate) } }}
              </p>
            </div>
            <div class="order-fran">
              <form>
                <div class="form-group">
                  <h3><span class="number">{{approvalData.username}}</span></h3>
                  <label>{{'signUp.userName'|translate}}</label>
                </div>
                <div class="form-group">
                  <div class="form-progress">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                        [ngStyle]="{width: (approvalData.reputation*20)+'%', 'background-color':(approvalData.reputation*20)<30?'#dc3545':(approvalData.reputation*20)<50?'#f8e600':'#28a745'}"
                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <span class="number">&nbsp;{{approvalData.reputation}}/5</span>
                  </div>
                  <label>{{'header.reputation'|translate}}</label>
                </div>
                <div class="form-group">
                  <h3><span class="number">{{(approvalData.averageResponseTimeInMinutes/60)|number:'1.0-2'}}</span>
                    {{'header.hours'|translate}}
                  </h3>
                  <label>{{'header.average_response'|translate}}</label>
                </div>
                <div class="form-group" *ngIf="selectedOrder.country">
                  <h3>{{selectedOrder.country}}</h3>
                  <label>{{'header.country'|translate}}</label>
                </div>
                <div class="form-group" *ngIf="approvalData.memberSince">
                  <h3><span class="number">{{approvalData.memberSince| date :'d.M.yyyy'}}</span></h3>
                  <label>{{'header.member_since'|translate}}</label>
                </div>
                <div class="form-group">
                  <h3><span class="number">{{approvalData.tradeVolume}}
                      {{userData.preferredCurrency.shortName}}</span></h3>
                  <label>{{'header.volume'|translate}}</label>
                </div>
                <div class="form-group">
                  <h3><span class="number">{{approvalData.numberOfTrades}}</span></h3>
                  <label>{{'header.trades'|translate}}</label>
                </div>
              </form>
            </div>
          </div>
          <div class="tab-content">
            <div class="order-preview-inner payment-datail-order">
              <div class="approve-order">
                <p *ngIf="userData.preferredLanguage === 'en'"> {{'header.your'|translate}}
                  <strong *ngIf="approvalData.methodName === 'International Bank Transfer'">
                    {{'buy_sell_detail.international_bank' | translate}}</strong>
                  <strong *ngIf="approvalData.methodName === 'National Bank Transfer'">
                    {{'buy_sell_detail.national_bank' | translate}}</strong>
                  <strong *ngIf="approvalData.methodName=== 'Transfer With Specific Bank'">
                    {{'buy_sell_detail.specific_bank' | translate}}</strong>
                  <strong *ngIf="approvalData.methodName !== 'International Bank Transfer' && approvalData.methodName !== 'National Bank Transfer' &&
                                                        approvalData.methodName !== 'Transfer With Specific Bank'">
                    {{approvalData.methodName}}</strong>

                  {{'header.order_taken'|translate}}
                  <strong><span class="number">{{approvalData.username}}</span></strong>
                  {{'header.total_of'|translate}}
                </p>

                <p *ngIf="userData.preferredLanguage !== 'en'">{{'header.your'|translate}}
                  {{'header.order_init'|translate}}
                  <strong *ngIf="approvalData.methodName === 'International Bank Transfer'">
                    {{'buy_sell_detail.international_bank' | translate}}</strong>
                  <strong *ngIf="approvalData.methodName === 'National Bank Transfer'">
                    {{'buy_sell_detail.national_bank' | translate}}</strong>
                  <strong *ngIf="approvalData.methodName=== 'Transfer With Specific Bank'">
                    {{'buy_sell_detail.specific_bank' | translate}}</strong>
                  <strong *ngIf="approvalData.methodName !== 'International Bank Transfer' && approvalData.methodName !== 'National Bank Transfer' &&
                                                        approvalData.methodName !== 'Transfer With Specific Bank'">
                    {{approvalData.methodName}}</strong>
                  {{'header.order_taken'|translate}}
                  <strong><span class="number">{{approvalData.username}}</span></strong>
                  {{'header.total_of'|translate}}
                </p>

                <h4><span class="number">{{approvalData.amount}} {{approvalData.coinShortName}}</span>
                </h4>
                <div class="total-amount">
                  <p>{{'header.total_cost'|translate}}
                    <span class="number">{{(approvalData.price*approvalData.amount)|number:'1.0-2'}}
                      {{approvalData.currency}}</span>
                  </p>
                </div>
                <ul class="pager wizard btn-center" [ngStyle]="{'pointer-events':loading?'none':'auto'}">
                  <li class="previous reject"><a href="javascript:;"
                      (click)="approveOrder(false)">{{'header.reject'|translate}}</a></li>
                  <li class="next"><a href="javascript:;"
                      (click)="approveOrder(true)">{{'header.approve'|translate}}</a>
                  </li>
                </ul>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- tour pop up  start -->
<div id="tour-popup" class="modal fade qrcode" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content boxs">
      <div class="modal-body boxs">
        <div class="qrcode_scan amount_div boxs">
          <div class="box_fom boxs" *ngIf="!this.tokenApp">
            <div class="form_bx noshadow whiteback hd_wht  boxs" style="padding: 17px 8px 17px;">
              <h5 class="textcolor">{{'tour.tour-title' | translate}}</h5>
              <div *ngFor="let sectionTour of ('tour.tour-sections' | translate) || []">
                <div (click)='tourSelected(sectionTour)' class="tour-options">
                  {{sectionTour}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- tour pop up end -->

<app-tour></app-tour>

<!-- blocked start -->
<div id="blocked-popup" class="modal fade qrcode" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content boxs">
      <div class="modal-body boxs">
        <div class="qrcode_scan amount_div boxs">
          <div class="box_fom boxs">
            <div class="form_bx noshadow whiteback hd_wht  boxs">
              <h5 class="textcolor">{{blockedMessage}}</h5>
              <div style="text-align: center;">
                <button class="btnLogOut textcolor" (click)="logOut()">
                  {{'sidebar.log_out'|translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- blocked end -->

<div id="accept-cookies" class="modal fade qrcode" role="dialog" style=" padding-left: 0px;" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content boxs">
      <div class="modal-body boxs">
        <div class="qrcode_scan amount_div boxs cookies">
          <div class="boxs conf_btn">
            <ul>
              <li>
                <h5>{{'term.we_use_cookies'|translate}} </h5>
              </li>
              <li><a href="javascript:;" data-dismiss="modal" class="accept">{{'accept'|translate}}</a>
              </li>
              <li><a href="javascript:;" data-dismiss="modal"
                  class="privacy_policy">{{'privacy_policy.title'|translate}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Start obsipayPopup -->
<app-quick-trasnfer-modal #obsipayModal></app-quick-trasnfer-modal>
<!-- End obsipayPopup -->

<!-- Start QuickExchangePopup -->
<!-- <app-quick-exchange-popup #quickExchangeModal></app-quick-exchange-popup> -->
<!-- End QuickExchangePopup -->
